export default "__VITE_ASSET__C$qH3J_X__"